import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_vxe_select = _resolveComponent("vxe-select");
  return _openBlock(), _createBlock(_component_vxe_select, _mergeProps({
    loading: $setup.loading,
    error: $setup.error,
    "option-props": {
      label: 'name',
      value: 'id'
    },
    options: $setup.depCateList
  }, _ctx.$attrs), null, 16, ["loading", "error", "options"]);
}